import { lazy } from 'react';
// project import
import Loadable from 'components/Loadable';
import MainLayout from 'layout/MainLayout';
import SettingsLayout from 'layout/SettingsLayout';
import MotionAlertSettingsPage from 'pages/settings/MotionAlertSettingsPage';
import NoMotionAlertSettingsPage from 'pages/settings/NoMotionAlertSettingsPage';
import FallDownAlertSettingsPage from 'pages/settings/FallDownAlertSettingsPage';
import TiltAlertSettingsPage from 'pages/settings/TiltAlertSettingsPage';
import OverSpeedAlertSettingsPage from 'pages/settings/OverSpeedAlertsPage';
import WorkModeSettingsPage from 'pages/settings/WorkModeSettingsPage';
import SpeakerVolumeSettingsPage from 'pages/settings/SpeakerVolumeSettingsPage';
import MicrophoneVolumeSettingsPage from 'pages/settings/MicrophoneVolumeSettingsPage';
import VoicePromptVolumeSettingsPage from 'pages/settings/VoicePromptVolumeSettingsPage';
import RingtoneVolumeSettingsPage from 'pages/settings/RingtoneVolumeSettingsPage';
import TimezoneSettingsPage from 'pages/settings/TimezoneSettingsPage';
import AdminStatsPage from 'pages/AdminStatsPage';

// render - dashboard
// const DashboardDefault = Loadable(lazy(() => import('pages/dashboard')));
// render - device page
const DeviceInfoPage = Loadable(lazy(() => import('pages/DeviceInfoPage')));
const AlertsPage = Loadable(lazy(() => import('pages/AlertsPage')));
const GpsTrackingPage = Loadable(lazy(() => import('pages/GpsTrackingPage')));
const HealthPage = Loadable(lazy(() => import('pages/HealthPage')));
const ReportsPage = Loadable(lazy(() => import('pages/ReportsPage')));
const UsageReportPage = Loadable(lazy(() => import('pages/UsageReportPage')));
// const DevicesPage = Loadable(lazy(() => import('pages/settings/DevicesPage')));
const GeoFenceSettingPage = Loadable(lazy(() => import('pages/settings/GeoFenceSettingsPage')));
const SetDeviceNamePage = Loadable(lazy(() => import('pages/settings/SetDeviceNamePage')));
const SosAlertEmailPage = Loadable(lazy(() => import('pages/settings/SosAlertEmailPage')));
const DummyPage = Loadable(lazy(() => import('pages/DummyPage')));
const DeeplinkHandler = Loadable(lazy(() => import('pages/DeeplinkHandler')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/:organizationName',
  element: <MainLayout />,
  children: [
    /* {
      path: '',
      element: <DeviceInfoPage />
    }, */
    // {
    //   path: 'dashboard',
    //   children: [
    //     {
    //       path: 'default',
    //       element: <DashboardDefault />
    //     }
    //   ]
    // },
    {
      path: 'device-info',
      element: <DeviceInfoPage />
    },
    {
      path: 'integrations/deeplink',
      element: <DeeplinkHandler />
    },
    {
      path: 'admin-stats',
      element: <AdminStatsPage/>
    },
    {
      path: 'alert',
      element: <AlertsPage />
    },
    {
      path: 'gps',
      element: <GpsTrackingPage />
    },
    {
      path: 'health',
      element: <HealthPage />
    },
    {
      path: 'reports',
      element: <ReportsPage />
    },
    {
      path: 'usage-reports',
      element: <UsageReportPage />
    },
    {
      path: 'settings',
      element: <SettingsLayout />,
      children: [
        // {
        //   path: 'devices',
        //   element: <DevicesPage />
        // },
        {
          path: 'set-device-name',
          element: <SetDeviceNamePage />
        },
        {
          path: 'dummy',
          element: <DummyPage />
        },
        {
          path: 'sos-alert',
          element: <SosAlertEmailPage />
        },
        {
          path: 'geo-fence-alert',
          element: <GeoFenceSettingPage />
        },
        {
          path: 'fall-down-alert',
          element: <FallDownAlertSettingsPage />
        },
        {
          path: 'motion-alert',
          element: <MotionAlertSettingsPage />
        },
        {
          path: 'no-motion-alert',
          element: <NoMotionAlertSettingsPage />
        },
        {
          path: 'tilt-alert',
          element: <TiltAlertSettingsPage />
        },
        {
          path: 'over-speed-alert',
          element: <OverSpeedAlertSettingsPage />
        },
        {
          path: 'work-mode-settings',
          element: <WorkModeSettingsPage />
        },
        {
          path: 'mic-volume-settings',
          element: <MicrophoneVolumeSettingsPage />
        },
        {
          path: 'speaker-volume-settings',
          element: <SpeakerVolumeSettingsPage />
        },
        {
          path: 'voice-prompt-volume-settings',
          element: <VoicePromptVolumeSettingsPage />
        },
        {
          path: 'ringtone-volume-settings',
          element: <RingtoneVolumeSettingsPage />
        },
        {
          path: 'timezone',
          element: <TimezoneSettingsPage />
        }
      ]
    }
  ]
};

export default MainRoutes;
